


export default {
    data() {
        return {
            likeUpsCount: 0,
            likeDownsCount: 0,
            currentState: 1
        }
    },
    props: [
        'itemId', 'likeups', 'likedowns', 'itemType'
    ],
    created() {
        this.likeUpsCount = this.likeups;
        this.likeDownsCount = this.likedowns;
        this.$nuxt.$on("successfully-logged", data => {
            if (data && data.next === 'submitLike' && data.props.itemId == this.itemId) {
                this.likeIt(this.currentState);
            }
        });
    },

    beforeDestroy() {
        this.$nuxt.$off('successfully-logged');
    },

    methods: {
        likeIt(like) {
            let vue = this;
            this.currentState = like;
            if (this.$auth.loggedIn) {
                vue.$axios.$post('/api/likes', {
                    item: vue.itemId,
                    type: vue.itemType,
                    like: this.currentState,
                })
                    .then(response => {
                        vue.likeUpsCount = response.likeUpsCount;
                        vue.likeDownsCount = response.likeDownsCount;
                    })
                    .catch(function (error) {
                    });

            }
            else {
                this.$nuxt.$emit("open-login-modal", {
                    mode: 'login',
                    next: 'submitLike',
                    props: { itemId: vue.itemId, itemType: vue.itemType }
                });
            }
        }
    },
}
